import React from 'react';
import { PowerUpState } from '../types/game';

interface PowerUpBarProps {
  remaining: PowerUpState;
  onFiftyFifty: () => void;
  onTimeFreeze: () => void;
  onSkip: () => void;
  disabled: boolean; // e.g. when an answer is already selected
}

const PowerUpBar: React.FC<PowerUpBarProps> = ({
  remaining,
  onFiftyFifty,
  onTimeFreeze,
  onSkip,
  disabled,
}) => {
  return (
    <div className="power-up-bar">
      <button
        className={`power-up-btn ${remaining.fiftyFifty <= 0 ? 'power-up-empty' : ''}`}
        onClick={onFiftyFifty}
        disabled={disabled || remaining.fiftyFifty <= 0}
        title="50/50 — Remove two wrong answers"
      >
        <span className="power-up-icon">&#9986;</span>
        <span className="power-up-count">{remaining.fiftyFifty}</span>
      </button>
      <button
        className={`power-up-btn ${remaining.timeFreeze <= 0 ? 'power-up-empty' : ''}`}
        onClick={onTimeFreeze}
        disabled={disabled || remaining.timeFreeze <= 0}
        title="Time Freeze — Pause the timer"
      >
        <span className="power-up-icon">&#10052;&#65039;</span>
        <span className="power-up-count">{remaining.timeFreeze}</span>
      </button>
      <button
        className={`power-up-btn ${remaining.skip <= 0 ? 'power-up-empty' : ''}`}
        onClick={onSkip}
        disabled={disabled || remaining.skip <= 0}
        title="Skip — Skip this question"
      >
        <span className="power-up-icon">&#9193;</span>
        <span className="power-up-count">{remaining.skip}</span>
      </button>
    </div>
  );
};

export default PowerUpBar;
